// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectSearch_grid-row-2__ds3fu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.SelectSearch_vm-20__wVfSz {
  margin: 20px 0;
}

.SelectSearch_divider-0__fmVnS {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.SelectSearch_rel__X8WZw {
  position: relative;
}

.SelectSearch_flex__f4FqR {
  display: flex;
}

.SelectSearch_jcc__Vo7Zo {
  justify-content: center !important;
}

.SelectSearch_input__\\+Zlje {
  position: relative;
  display: flex;
  flex-direction: column;
}
.SelectSearch_input__required__\\+hOV2 {
  position: absolute;
  top: 9px;
  left: 13px;
  color: #7d838a;
  pointer-events: none;
}
.SelectSearch_input__required__sign__8DWQO {
  color: red;
}
.SelectSearch_input__\\+Zlje input {
  position: relative;
  display: flex;
  align-items: center;
  width: 416px;
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #E1E5EA;
  font-size: 14px;
  color: #000000;
  cursor: pointer;
}
.SelectSearch_input__\\+Zlje input::placeholder {
  color: #7d838a;
  opacity: 1;
}
.SelectSearch_input__\\+Zlje input:focus {
  outline: none !important;
  border: 1px solid #344045;
}
.SelectSearch_input_disabled__Z0SDz input {
  background-color: #e9eaea;
}
.SelectSearch_input_invalid__PoirD input {
  border: 1px solid #ee505a;
}
.SelectSearch_input_fullwidth__cLQrH input {
  width: 100%;
}
.SelectSearch_input__error__iCFs1 {
  color: #ee505a;
  padding-top: 4px;
  line-height: 22px;
  max-width: 416px;
}

.SelectSearch_select__VEZw3 {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 5px;
  top: 45px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(214, 214, 215, 0.5);
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  max-height: 168px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  transition: 0.2s;
  z-index: 4;
  opacity: 1;
}
.SelectSearch_select__cross__Fat\\+L {
  margin-top: 2px;
  cursor: pointer;
}
.SelectSearch_select_hidden__cuR4d {
  top: 30%;
  left: 0px;
  width: 100%;
  max-height: 0px;
  z-index: -1;
  opacity: 0;
}
.SelectSearch_select__item__fjvfG {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 30px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 14px;
  width: 100%;
  word-wrap: break-word;
  cursor: pointer;
  flex-shrink: 0;
}
.SelectSearch_select__item__fjvfG:hover {
  background-color: rgba(214, 214, 215, 0.5);
}
.SelectSearch_select__item__fjvfG:hover .SelectSearch_select__item__text__mobd9::after {
  opacity: 0;
}
.SelectSearch_select__item__text__mobd9 {
  white-space: nowrap;
  overflow: hidden;
}
.SelectSearch_select__item__text__mobd9::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) -10%, rgb(255, 255, 255) 50%);
  pointer-events: none;
  opacity: 1;
}
.SelectSearch_select__arrow__lNaGO {
  position: absolute;
  cursor: pointer;
  right: 13px;
  top: 8px;
  display: block;
  color: #000000;
  transition: all ease-in-out 0.2s;
}
.SelectSearch_select__arrow_expanded__ySi-C {
  transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/components/ui/Form/SelectSearch/SelectSearch.module.scss","webpack://./src/assets/helpers/colors.scss","webpack://./src/assets/helpers/constants.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;AAxBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AA2BF;AAzBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cCQI;EDPJ,oBAAA;AA2BJ;AAzBI;EACE,UAAA;AA2BN;AAvBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YEtBQ;EFuBR,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cCNO;EDOP,eAAA;AAyBJ;AAvBI;EACE,cCdE;EDeF,UAAA;AAyBN;AAtBI;EACE,wBAAA;EACA,yBAAA;AAwBN;AAnBI;EACE,yBCxCE;AD6DR;AAhBI;EACE,yBAAA;AAkBN;AAbI;EACE,WAAA;AAeN;AAXE;EACE,cCtBE;EDuBF,gBAAA;EACA,iBAAA;EACA,gBEhEQ;AF6EZ;;AATA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,2CAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AAYF;AALE;EACE,eAAA;EACA,eAAA;AAOJ;AAJE;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;AAMJ;AAHE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AAKJ;AAHI;EACE,0CC5Ce;ADiDrB;AAFQ;EACE,UAAA;AAIV;AACI;EACE,mBAAA;EACA,gBAAA;AACN;AACM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uFCzEc;ED0Ed,oBAAA;EACA,UAAA;AACR;AAIE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,cChII;EDiIJ,gCAAA;AAFJ;AAII;EACE,wBAAA;AAFN","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import '../../../../assets/helpers/index.scss';\n\n.input {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  &__required {\n    position: absolute;\n    top: 9px;\n    left: 13px;\n    color: $smallText;\n    pointer-events: none;\n\n    &__sign {\n      color: red;\n    }\n  }\n\n  input {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: $formWidth;\n    height: 40px;\n    padding: 0 12px;\n    border-radius: 12px;\n    border: 1px solid $selectBorderColor;\n    font-size: 14px;\n    color: $headText;\n    cursor: pointer;\n\n    &::placeholder {\n      color: $smallText;\n      opacity: 1;\n    }\n\n    &:focus {\n      outline: none !important;\n      border: 1px solid $grayAsphalt;\n    }\n  }\n\n  &_disabled {\n    input {\n      background-color: $gray2;\n    }\n  }\n\n  &_invalid {\n    input {\n      border: 1px solid $danger;\n    }\n  }\n\n  &_fullwidth {\n    input {\n      width: 100%;\n    }\n  }\n\n  &__error {\n    color: $danger;\n    padding-top: 4px;\n    line-height: 22px;\n    max-width: $formWidth;\n  }\n}\n\n.select {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-top: 5px;\n  top: 45px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid $borderOpacityColor;\n  box-shadow: 0px 1px 6px $boxShadowColor;\n  background-color: #fff;\n  max-height: 168px;\n  overflow-y: scroll;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  transition: 0.2s;\n  z-index: 4;\n  opacity: 1;\n\n\n  //&::-webkit-scrollbar {\n  //  display: none;\n  //}\n\n  &__cross {\n    margin-top: 2px;\n    cursor: pointer;\n  }\n\n  &_hidden {\n    top: 30%;\n    left: 0px;\n    width: 100%;\n    max-height: 0px;\n    z-index: -1;\n    opacity: 0;\n  }\n\n  &__item {\n    position: relative;\n    display: flex;\n    align-items: center;\n    min-height: 30px;\n    background-color: #fff;\n    padding: 5px 10px;\n    font-size: 14px;\n    width: 100%;\n    word-wrap: break-word;\n    cursor: pointer;\n    flex-shrink: 0;\n\n    &:hover {\n      background-color: $borderOpacityColor;\n\n      & .select__item__text {\n        &::after {\n          opacity: 0;\n        }\n      }\n    }\n\n    &__text {\n      white-space: nowrap;\n      overflow: hidden;\n\n      &::after {\n        content: \"\"; \n        position: absolute;\n        right: 0;\n        bottom: 0;\n        width: 25px;\n        height: 100%;\n        background: $gradientPlaceholder; \n        pointer-events: none;\n        opacity: 1;\n      }\n    }\n  }\n\n  &__arrow {\n    position: absolute;\n    cursor: pointer;\n    right: 13px;\n    top: 8px;\n    display: block;\n    color: $mainText;\n    transition: all ease-in-out .2s;\n\n    &_expanded {\n      transform: rotate(90deg);\n    }\n  }\n}\n","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;","$headerHeight: 70px;\n$formWidth: 416px;\n$horizontalPadding: 204px;\n$mainBorderRadius: 16px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-row-2": `SelectSearch_grid-row-2__ds3fu`,
	"vm-20": `SelectSearch_vm-20__wVfSz`,
	"divider-0": `SelectSearch_divider-0__fmVnS`,
	"rel": `SelectSearch_rel__X8WZw`,
	"flex": `SelectSearch_flex__f4FqR`,
	"jcc": `SelectSearch_jcc__Vo7Zo`,
	"input": `SelectSearch_input__+Zlje`,
	"input__required": `SelectSearch_input__required__+hOV2`,
	"input__required__sign": `SelectSearch_input__required__sign__8DWQO`,
	"input_disabled": `SelectSearch_input_disabled__Z0SDz`,
	"input_invalid": `SelectSearch_input_invalid__PoirD`,
	"input_fullwidth": `SelectSearch_input_fullwidth__cLQrH`,
	"input__error": `SelectSearch_input__error__iCFs1`,
	"select": `SelectSearch_select__VEZw3`,
	"select__cross": `SelectSearch_select__cross__Fat+L`,
	"select_hidden": `SelectSearch_select_hidden__cuR4d`,
	"select__item": `SelectSearch_select__item__fjvfG`,
	"select__item__text": `SelectSearch_select__item__text__mobd9`,
	"select__arrow": `SelectSearch_select__arrow__lNaGO`,
	"select__arrow_expanded": `SelectSearch_select__arrow_expanded__ySi-C`
};
export default ___CSS_LOADER_EXPORT___;
